/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * status loggerのリクエスト
 * @export
 * @interface StatusLogRequest
 */
export interface StatusLogRequest {
    /**
     * 
     * @type {string}
     * @memberof StatusLogRequest
     */
    office?: string;
    /**
     * 
     * @type {string}
     * @memberof StatusLogRequest
     */
    user: string;
    /**
     * 
     * @type {string}
     * @memberof StatusLogRequest
     */
    resource?: string;
    /**
     * 
     * @type {object}
     * @memberof StatusLogRequest
     */
    details?: object;
    /**
     * 
     * @type {string}
     * @memberof StatusLogRequest
     */
    statusType?: string;
    /**
     * 
     * @type {string}
     * @memberof StatusLogRequest
     */
    sessionKey?: string;
}

export function StatusLogRequestFromJSON(json: any): StatusLogRequest {
    return StatusLogRequestFromJSONTyped(json, false);
}

export function StatusLogRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatusLogRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'office': !exists(json, 'office') ? undefined : json['office'],
        'user': json['user'],
        'resource': !exists(json, 'resource') ? undefined : json['resource'],
        'details': !exists(json, 'details') ? undefined : json['details'],
        'statusType': !exists(json, 'statusType') ? undefined : json['statusType'],
        'sessionKey': !exists(json, 'sessionKey') ? undefined : json['sessionKey'],
    };
}

export function StatusLogRequestToJSON(value?: StatusLogRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'office': value.office,
        'user': value.user,
        'resource': value.resource,
        'details': value.details,
        'statusType': value.statusType,
        'sessionKey': value.sessionKey,
    };
}


